import { frontendURL } from '../../../../helper/URLHelper';

const contacts = accountId => ({
  parentNav: 'contacts',
  routes: [
    'contacts_dashboard',
    'contact_profile_dashboard',
    'contacts_segments_dashboard',
    'contacts_labels_dashboard',
    'contacts_portfolio',
    'contacts_portfolio_distribution',
    'contacts_ddd_assignments',
  ],
  menuItems: [
    {
      icon: 'contact-card-group',
      label: 'ALL_CONTACTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts`),
      toStateName: 'contacts_dashboard',
    },
    {
      icon: 'people-team',
      label: 'CARTEIRIZACAO',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts/portfolio`),
      toStateName: 'contacts_portfolio',
    },
    {
      icon: 'chart-multiple',
      label: 'PORTFOLIO_DISTRIBUTION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts/portfolio/distribution`),
      toStateName: 'contacts_portfolio_distribution',
    },
    {
      icon: 'automation',
      label: 'DDD_ASSIGNMENTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/contacts/ddd-assignments`),
      toStateName: 'contacts_ddd_assignments',
    },
  ],
});

export default contacts;
